export const MinimumMultiplier = 0.5;
export const DefaultMaxAmount = 3000;
export const DefaultMinAmount = 2;
export const MinMultiply = MinimumMultiplier + 0.01;
export const MaxMultiply = 100000;
export const LowThreshold = 1.4;
export const CrashFinishedTimeout = 3000;
export const CrashStateLagThreshold = 300;
export const CrashStateDisconnectThreshold = 3000;
